import { styled, InputBase, FormLabel } from '@mui/material';

export const ButtonFileUploadInput = styled(InputBase)({
  display: 'none',
});

export const ButtonFileUploadInputLabel = styled(FormLabel)({
  maxWidth: 'max-content',
  flex: 1,
});
